import { BracketProps } from './Bracket';
import { useMobile } from 'src/hooks/useMobile';
import { BracketLoserColumnsStack } from './BracketLoserColumnsStack';
import { useGenerateBracketLoser } from 'src/hooks/useGenerateBracketLoser';

export const CONNECTORS = {
  ['8-mobile']: { width: 1304, height: 748, size: 32 },
  ['6-mobile']: { width: 880, height: 294, size: 16 },
  ['4-mobile']: { width: 456, height: 268, size: 8 },
  ['2-mobile']: { width: 32, height: 32, size: 4 },
  ['8']: { width: 1172, height: 814, size: 32 },
  ['6']: { width: 750, height: 368, size: 16 },
  ['4']: { width: 244, height: 256, size: 8 },
  ['2']: { width: 180, height: 32, size: 4 },
};

export function BracketLoser({ rounds, Match }: BracketProps) {
  const isMobile = useMobile();
  const {
    mobileColumns,
    matchColumnsCenter,
    matchColumnsLeft,
    matchColumnsRight,
  } = useGenerateBracketLoser(rounds, Match);

  const connectorSx =
    CONNECTORS[`${rounds.length}${isMobile ? '-mobile' : ''}`];

  return (
    <BracketLoserColumnsStack
      fullHeight={rounds.length === 2}
      connectorSx={connectorSx}
    >
      {isMobile
        ? mobileColumns
        : [matchColumnsLeft, matchColumnsCenter, matchColumnsRight]}
    </BracketLoserColumnsStack>
  );
}
